import React from 'react';
import { FaEye, FaDownload } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

const getFileIcon = (fileType) => {
  switch (fileType) {
    case 'pdf':
      return 'fa-file-pdf'; // PDF file
    case 'docx':
      return 'fa-file-word'; // DOCX file
    case 'xlsx':
      return 'fa-file-excel'; // XLSX file
    case 'jpg':
    case 'jpeg':
    case 'png':
      return 'fa-file-image'; // Image files
    case 'txt':
      return 'fa-file-alt'; // Text file
    default:
      return 'fa-file'; // Generic file icon
  }
};

const FileIcon = ({ fileName, fileBase64 }) => {
  const fileType = fileName.split('.').pop(); // Get file extension
  const fileIconClass = getFileIcon(fileType);

  // Function to trigger file download
  const downloadFile = () => {
    const link = document.createElement('a');
    link.href = fileBase64;
    link.download = fileName;
    link.click();
  };

  // Function to handle file preview
  const previewFile = () => {
    if (fileType === 'pdf') {
      window.open(fileBase64, '_blank');
    } else if (['jpg', 'jpeg', 'png'].includes(fileType)) {
      const img = new Image();
      img.src = fileBase64;
      const w = window.open('');
      w.document.write(img.outerHTML);
    } else {
      alert('Preview not supported for this file type');
    }
  };

  return (
    <div className="d-flex align-items-center">
      <i className={`fas ${fileIconClass} fa-2x me-3`} />
      <div className="me-3">
        <Button variant="link" onClick={previewFile} title="Preview">
          <FaEye />
        </Button>
      </div>
      <div>
        <Button variant="link" onClick={downloadFile} title="Download">
          <FaDownload />
        </Button>
      </div>
    </div>
  );
};

export default FileIcon;
